import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import './css/index.scss';

class RequestTab extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      
    };
  }

  componentDidMount() {
    this.props.getMyTabs();
    window.gtag('event', 'conversion', {'send_to': 'AW-985636019/ADpFCPr0gY8BELO5_tUD'})
  }  

  render () {
    return (
      <div className="myTabsContainer">
        <div className="mainHeader"></div>
        <div className="container">
          <div className="article">
            <Link className="regularLink" style={{float: 'right', marginTop: '22px'}} to="/adauga-tabulatura">+ Adaugă Tabulatură</Link>
            <h1>Tabulaturile Mele</h1>
            <h2>Propuneri {this.props.myTabs !== null && this.props.myTabs.submissions.length > 0 ? '(' + this.props.myTabs.submissions.length + ')' : null}</h2>
            {this.props.myTabs !== null ? 
            (
                this.props.myTabs.submissions.length > 0 ? (<div>
                    {this.props.myTabs.submissions.map((submission) => {
                        let addedDate = moment(submission.created_at);
                        return <div key={`s${submission.id}`} className="tab-line">{submission.artist} - <b>{submission.title}</b> <span style={{float: 'right'}}>adăugat la {addedDate.format('DD/MM/YYYY - HH:mm')}</span><div style={{clear: 'both'}}></div></div>
                    })}
                </div>) : (<div> - Nu ai nicio tabulatură propusă. Poți propune tabulaturi spre aprobare <Link className="regularLink" to="/adauga-tabulatura">aici</Link> - </div>)
            )
            : null}
            <h2>Aprobate {this.props.myTabs !== null && this.props.myTabs.tabs.length > 0 ? '(' + this.props.myTabs.tabs.length + ')' : null}</h2>
            {this.props.myTabs !== null ? 
            (
                this.props.myTabs.tabs.length > 0 ? (<div>
                  {this.props.myTabs.tabs.map((tab) => {
                        let addedDate = moment(tab.created_at);
                        return <Link style={{color: '#007bd9'}} to={`/tabulatura/${tab.id}`} key={`t${tab.id}`}><div className="tab-line">{tab.artist.name} - <b>{tab.title}</b> <span style={{float: 'right'}}>adăugat la {addedDate.format('DD/MM/YYYY - HH:mm')}</span><div style={{clear: 'both'}}></div></div></Link>
                    })}
                </div>) : (<div> - Nu ai nicio tabulatură aprobată. Poți propune tabulaturi spre aprobare <Link className="regularLink" to="/adauga-tabulatura">aici</Link> - </div>)
            )
            : null}
          </div>
        </div>
      </div>
    );
  }
}

export default RequestTab;



// WEBPACK FOOTER //
// ./src/components/myTabs/myTabs.js